import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n"; // Import i18n configuration
import "./generated-tokens/variables.css"; // Import design tokens
import "./generated-tokens/variables-dark.css"; // Dark theme tokens (data-theme="dark")
import { initTheme } from "./theme";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

initTheme();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
